import $ from 'jquery'

/* @ngInject */
const routingRun = (
  toaster,
  $rootScope,
  $transitions,
  $timeout,
  $$setting,
  $$account,
  mainMenu,
  homeMenu,
  userService
) => {
  $rootScope.$on('loading:progress', () => {
    $rootScope.loading = true
  })

  $rootScope.$on('loading:finish', () => {
    $rootScope.loading = false
    $timeout(() => {
      $('select.select-active').material_select()
      $('label').addClass('active')
    })
  })

  $transitions.onSuccess({}, (trans) => {
    if ($$setting.data.general.checkboxs.scrollTop.model) {
      $timeout(() => {
        if (document.body.scrollTop > 70) {
          document.body.scrollTop = 70
        }
      })
    }
    toaster.toastTimer = $$setting.data.general.sliders.toastTimer.model * 1000
  })

  $transitions.onSuccess({
    entering: 'index.*',
  }, (trans) => {
    $timeout(() => {
      if (!userService.isLog() && !userService.tryLogin) {
        $$account.ask.askLogin()
      }
    }, 1500)
  })

  $transitions.onBefore({}, (trans) => {
    if (trans.from().name.split('.')[0] === 'consult' && trans.to().name === 'consult') {
      window.history.back()
    }

    $rootScope.pageTitle = trans.to().data.pageTitle

    const state = trans.to().name

    for (let i = 0; i < mainMenu.length; i++) {
      if (state.toString().indexOf(mainMenu[i].ref) !== -1) {
        mainMenu[i].isActive = true
      } else {
        mainMenu[i].isActive = false
      }
    }

    for (let i = 0; i < homeMenu.length; i++) {
      if (state.toString().indexOf(homeMenu[i].ref) !== -1) {
        homeMenu[i].isActive = true
      } else {
        homeMenu[i].isActive = false
      }
    }
  })

  $transitions.onSuccess({}, (trans) => {
    if (trans.to().name.match('index.consult')) {
      const subMenu = trans.to().name.split('.')[2]
      $rootScope.consultMenu.radio.value = subMenu
    } else if (trans.to().name.match('index.maneuver')) {
      const subMenu = trans.to().name.split('.')[2]
      $rootScope.maneuverMenu.radio.value = `${subMenu}Menu`
    }
  })
}

export default routingRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/routing.run.js